import { change } from "redux-form";

import { RESIDUAL_SECTION_NAME } from "globalConstants";

export const dispatchChangeScheduleAFirstAsDefault = (
	dispatch,
	formName,
	scheduleAs,
) => {
	if (scheduleAs?.length === 1) {
		dispatch(
			change(
				formName,
				`${RESIDUAL_SECTION_NAME}.scheduleA`,
				scheduleAs[0],
			),
		);
	} else {
		dispatch(
			change(formName, `${RESIDUAL_SECTION_NAME}.scheduleA`, { id: "" }),
		);
	}
};
